enum PolicyTermStatus {
	CANCELED = 'Canceled',
	IN_EFFECT = 'InEffect',
	PENDING_PAYMENT = 'PendingPayment',
	PAID_PENDING_EFFECTIVE_DATE = 'PaidPendingEffectiveDate',
	PAST = 'Past',
}

export default PolicyTermStatus;